import { LOCAL_STORAGE_KEYS } from "@/data_source/constants";
import {
  currentApiEnvironmentId,
  type ApiEnvironmentId
} from "@/data_source/constants/apiEnvironment";
import { applySelectedApiEnvironment } from "@/data_source/constants/env";
import request, { abortPendingRequests } from "@/utils/request";
import { RequestCacheBuilder } from "@/utils/request/cache";

const CLEARED_AUTH_COOKIE =
  "auth_token=; Path=/; Domain=.sitehubpro.com; Max-Age=0; SameSite=Lax; Secure";

export function switchApiEnvironment(next: ApiEnvironmentId): void {
  if (currentApiEnvironmentId() === next) return;

  abortPendingRequests();
  applySelectedApiEnvironment(next);
  RequestCacheBuilder.getInstance().clear();
  localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem("token");
  request.setGlobalHeader({
    Authorization: ""
  });
  document.cookie = CLEARED_AUTH_COOKIE;
}
